import { h } from 'vue'

export class User {
  id = 0
  firstName = ''
  lastName = ''
  email = ''
  street = ''
  hNr = ''
  plz = ''
  city = ''
  country = ''
  phone = ''

  static emptyUser () {
    return new User()
  }

  static newUser (id:number, firstName:string, lastName:string, email:string,
    street:string, hNr:string, plz:string, city:string, country:string, phone:string) {
    const user = new User()

    user.id = id
    user.firstName = firstName
    user.lastName = lastName
    user.email = email
    user.street = street
    user.hNr = hNr
    user.plz = plz
    user.city = city
    user.country = country
    user.phone = phone

    return user
  }

  copyUser (userToCopy:User) {
    this.id = userToCopy.id
    this.firstName = userToCopy.firstName
    this.lastName = userToCopy.lastName
    this.email = userToCopy.email
    this.street = userToCopy.street
    this.hNr = userToCopy.hNr
    this.plz = userToCopy.plz
    this.city = userToCopy.city
    this.country = userToCopy.country
    this.phone = userToCopy.phone
  }
}
